export default __webpack_public_path__ + "static/media/multiasset-balancing-mob.81d8d35c.jpg";